import { Engine } from "@babylonjs/core/Engines/engine";
import { createScene } from "./render/scene";
import { installErrorOverlay, reportError } from "./diagnostics";

function boot(): void {
  installErrorOverlay(); // surface uncaught errors on-screen (no console in a headset)

  const canvas = document.getElementById("renderCanvas") as HTMLCanvasElement | null;
  if (!canvas) throw new Error("renderCanvas not found");

  const engine = new Engine(canvas, true, {
    // Depth+antialias tuned for standalone headsets; adjust per profiling.
    preserveDrawingBuffer: false,
    stencil: false,
    disableWebGL2Support: false,
  });

  const scene = createScene(engine, canvas);

  // Dev-only diagnostic handle for the headless smoke test.
  if (import.meta.env.DEV) (window as unknown as { __scene: unknown }).__scene = scene;

  // A throw inside the render loop would otherwise wedge the frame silently
  // (and invisibly, in a headset). Surface the first one on the error panel.
  let reportedRenderError = false;
  engine.runRenderLoop(() => {
    try {
      scene.render();
    } catch (e) {
      if (!reportedRenderError) {
        reportedRenderError = true;
        reportError("render", e);
      }
    }
  });

  window.addEventListener("resize", () => engine.resize());
}

boot();
